import React from "react";
import { withTranslation } from "react-i18next";
import { Alert, Button, ProgressBar } from "react-bootstrap";
import { ScaleLoader } from "react-spinners";
import { useAnomalyDetection } from "./AnomalyDetectionContext";

const AnomalyDetectionProgress = ({ t }) => {
  const {
    status,
    progressPct,
    totalRules,
    processedRules,
    errorMessage,
    pollError,
    monthLabel,
    isJobActive,
    clearJob,
  } = useAnomalyDetection();

  const showFailed = status === "FAILED" && (errorMessage || pollError);
  const showPollError = pollError && !isJobActive && status !== "FAILED";
  const showProgress = isJobActive;

  if (!showProgress && !showFailed && !showPollError) {
    return null;
  }

  const isPending = status === "PENDING" || totalRules == null;

  return (
    <div
      className="anomaly-detect-progress"
      data-testid="anomaly-detect-progress"
      role="status"
      aria-live="polite"
    >
      {showProgress && (
        <div className="anomaly-detect-progress-body">
          <div className="anomaly-detect-progress-header">
            <span className="anomaly-detect-progress-title">
              {monthLabel
                ? t("AnomalyDetection.detectStarted.label", { month: monthLabel })
                : t("AnomalyDetection.detectProgressPending.label")}
            </span>
            {isPending && (
              <ScaleLoader color="#3b82f6" height={12} width={2} />
            )}
          </div>

          {isPending ? (
            <ProgressBar animated striped now={100} className="anomaly-detect-progress-bar" />
          ) : (
            <ProgressBar
              now={progressPct}
              label={`${progressPct}%`}
              className="anomaly-detect-progress-bar"
            />
          )}

          <p className="anomaly-detect-progress-label">
            {isPending
              ? t("AnomalyDetection.detectProgressPending.label")
              : t("AnomalyDetection.detectProgress.label", {
                  processed: processedRules,
                  total: totalRules,
                })}
          </p>
        </div>
      )}

      {showFailed && (
        <Alert variant="danger" className="anomaly-detect-progress-alert">
          <Alert.Heading>{t("AnomalyDetection.detectFailed.label")}</Alert.Heading>
          <p>{errorMessage || pollError}</p>
          <Button variant="outline-danger" size="sm" onClick={clearJob}>
            {t("Close.label")}
          </Button>
        </Alert>
      )}

      {showPollError && (
        <Alert variant="danger" className="anomaly-detect-progress-alert">
          <p>{pollError}</p>
          <Button variant="outline-danger" size="sm" onClick={clearJob}>
            {t("Close.label")}
          </Button>
        </Alert>
      )}
    </div>
  );
};

export default withTranslation()(AnomalyDetectionProgress);
